import axios from 'axios'
import config from '@/config.js'
import { getStatic } from '@/services/data-source.js'

const API_URL = config.apiUrl

const state = {
  corpuses: [],
}

const mutations = {
  setCorpuses(state, corpuses){
    state.corpuses = corpuses.sort(function(a, b) {return a.edition.sigleLegam > b.edition.sigleLegam ? 1 : 0})
  },
}

const getters = {
}

const actions = {
  searchCorpuses({ commit }, options){
    let query = options.query
    let exclude = (options.exclude || []).join(',')
    axios
      .get(`${API_URL}/corpuses/autocomplete?query=${query}&exclude=${exclude}`)
      .then(r => r.data)
      .then(corpuses => {
        commit('setCorpuses', corpuses)
      })
  },
  loadAllCorpuses({ commit, dispatch }){
    const request = config.staticData
      ? getStatic('corpora.json').catch(() => getStatic('documents.json', {cache: false}).then(response => {
        const corpora = new Map()
        response.data.forEach(document => {
          const corpus = Array.isArray(document) ? document[1] : document.corpus
          if (corpus && corpus.id && !corpora.has(String(corpus.id))) {
            const name = corpus.name || corpus.identifier || String(corpus.id)
            corpora.set(String(corpus.id), {
              id: corpus.id,
              identifier: name,
              name: name,
              display: name,
              edition: {sigleLegam: name},
            })
          }
        })
        return {data: [...corpora.values()]}
      }))
      : axios.get(`${API_URL}/corpuses/all`)
    return request
      .then(r => r.data)
      .then(corpuses => {
        commit('setCorpuses', corpuses)
        return corpuses
      })
      .catch(error => {
        dispatch('addNotification', {
          type: 'danger',
          text: 'Corpus data is unavailable in this export',
        })
        throw error
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
